import { styled } from '@/stitches/index.js';

export const Divider = styled('span', {
  backgroundColor: '$defaultFont',
  height: '$28',
  width: '$1',
});

export const AboutHeading = styled('span', {
  fontSize: '$48',
  fontWeight: 500,
  letterSpacing: '-$1',
  lineHeight: 1.4,
});

export const BioText = styled('p', {
  fontSize: '$24',
  lineHeight: 1.4,
  textAlign: 'center',
  width: '80%',
});

export const LocationContainer = styled('div', {
  '& > svg': {
    flexShrink: 0,
  },
  alignItems: 'center',
  display: 'flex',
  gap: '$12',
  span: {
    fontSize: '$18',
    fontWeight: 500,
    letterSpacing: '$1_5',
    textTransform: 'uppercase',
  },
});
